export default [
  {
    path: '/b',
    name: 'bDashboard',
    component: () => import('@/views/b/dashboard/Index.vue'),
    meta: {
      pageTitle: 'Dashboard',
      action: 'Lihat',
      resource: 'b-dashboard',
    },
  },
]
